import React from "react";

const BubbleBackground = ({ children }) => {
  return (
    <div
      className="
        relative min-h-screen overflow-hidden
        bg-gradient-to-br
        from-blue-100 via-gray-100 to-slate-200
      "
    >
      {/* Soft but visible bubbles */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-14 left-10 w-48 h-48 bg-blue-400/25 rounded-full blur-2xl" />

        <div className="absolute top-1/4 right-16 w-64 h-64 bg-slate-400/20 rounded-full blur-3xl" />

        <div className="absolute bottom-24 left-1/4 w-40 h-40 bg-blue-300/30 rounded-full blur-2xl" />

        <div className="absolute bottom-16 right-12 w-56 h-56 bg-orange-300/25 rounded-full blur-2xl" />

        <div
          className="
            absolute top-1/2 left-1/2
            w-80 h-80
            bg-blue-300/30
            rounded-full blur-3xl
            -translate-x-1/2 -translate-y-1/2
          "
        />
      </div>

      {/* Page content */}
      <div className="relative z-10 min-h-screen">
        {children}
      </div>
    </div>
  );
};

export default BubbleBackground;
